import styled from "styled-components";

export const FooterWrapper = styled.div`
    & > table {
        width: 100%;
        table-layout: fixed;
    }
`;
